module.exports = __webpack_public_path__ + "static/media/plus.c8cf9dc7.png";